/* eslint-disable import/no-cycle */
import { format } from "date-fns/fp";

export { default as getEnv } from "./getEnv";
export {
    default as fetchApi,
    logFetchError,
    userFacingFetchMessage,
} from "./fetchApi";
export {
    timeoutInit,
    isAbortError,
    FETCH_TIMEOUT_MESSAGE,
} from "./fetchTimeout";

export const round = (num: number, places: number) =>
    Math.round((num + Number.EPSILON) * 10 ** places) / 10 ** places;

export const usDateFormat = format("M/dd/yyyy h:mm:ss aa");
export const verboseDateFormat = format("LLLL d, yyyy");
export const terseTimeFormat = format("M/dd/yyyy hh:mm aa");
export const terseDateFormat = format("M/dd/yyyy");
export const isoDateFormat = format("yyyy-MM-dd");
export const timeOnlyFormat = format("h:mm aa");
